import { Button, Stack, Typography } from "@mui/material";
import Modal from "@/components/modal";
import { toast } from "sonner";
import { useDeleteSuggestedSearchMutation } from "@/app/features/suggestedSearch/suggestedSearchApiSlice";

export default function SuggestedSearchDeleteModal({
  open,
  handleClose,
  selectedItem,
}) {
  const [deleteSuggestedSearch, { isLoading }] =
    useDeleteSuggestedSearchMutation();

  const handleDelete = async () => {
    try {
      const result = await deleteSuggestedSearch(selectedItem.id);
      if (result?.error) {
        toast.error(result.error?.data?.message || "Failed to delete");
        return;
      }
      toast.success("Suggested search deleted");
      handleClose();
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
    }
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Delete suggested search?
      </Typography>
      <Typography sx={{ mb: 2 }}>
        Are you sure you want to delete &quot;{selectedItem?.label}&quot;?
      </Typography>
      <Stack direction="row" alignItems="center" justifyContent="center" mt={2}>
        <Button
          variant="contained"
          fullWidth
          onClick={handleDelete}
          disabled={isLoading}
        >
          Delete
        </Button>
      </Stack>
    </Modal>
  );
}
